<div class="admin-page-wrapper">

  <div class="admin-review-memberships">
    <div class="tabs">
      <button [class.active]="activeTab === 'pending'" (click)="activeTab = 'pending'">Pending</button>
      <button [class.active]="activeTab === 'decisions'" (click)="activeTab = 'decisions'">Decisions</button>
    </div>

    <div *ngIf="activeTab === 'pending'" class="pending">
      <input type="text" class="input-dark" placeholder="Search by email" [(ngModel)]="search"
        (input)="applyFilter()" />
      <table>
        <thead>
          <tr>
            <th>Created At</th>
            <th>Name</th>
            <th>Acct Info</th>
            <th>Provider</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let review of filtered" (click)="select(review)">
            <td>{{ review.createdAt.toDate() | date:'MM/dd/yy hh:mm a' }}</td>
            <td>{{ review?.profile?.fullName }}</td>
            <td>
              <div>{{ review.email }}</div>
              <div>{{ review?.profile?.mobileNumber }}</div>
            </td>
            <td>{{ review.provider }}</td>
            <td>{{ review.reviewType === 'soft' ? 'Soft access' : 'Hard review' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="activeTab === 'decisions'" class="decisions">
      <table>
        <thead>
          <tr>
            <th>Email</th>
            <th>Provider</th>
            <th>Decision</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of decisions">
            <td>{{ d.email }}</td>
            <td>{{ d.provider }}</td>
            <td>{{ d.decision }}</td>
            <td>{{ d.decidedAt | date: 'short' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal" *ngIf="selected">
      <div class="modal-loading" *ngIf="isProcessingDecision">
        <app-spinner size="28px"></app-spinner>
      </div>
      <div class="modal-content" *ngIf="!isProcessingDecision">
        <p>{{ selected.profile?.fullName }} ({{ selected.email }})</p>
        <p>Membership Provider: {{ selected.provider }}</p>
        <p>Review Type: {{ selected.reviewType === 'soft' ? 'Soft access granted' : 'Hard verification required' }}</p>
        <pre>Membership Data: {{ selected.membershipData | json }}</pre>
        <p>Missing signals: {{ selected.missingSignals.join(', ') }}</p>
        <p>Matched signals: {{ selected.matchedSignals.join(', ') }}</p>
        <p>File info: {{ selected.fileInfo }}</p>
        <a [href]="selected.pdfUrl" target="_blank">View PDF</a>

        <div class="decision-input">
          <app-base-text-area [(ngModel)]="declineReason" placeholder="Reason or message to user"
            [isFluid]="true"></app-base-text-area>
        </div>
        <div class="actions">
          <button (click)="approve()">Approve</button>
          <button (click)="requireHardReview()">Require Hard Verification</button>
          <button (click)="decline()">Decline</button>
          <button (click)="closeModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
